import { Usuario } from "../../../../interfaces/usuario";

export class TareaResponsable {
    constructor(
        public IdTareaResponsable?: number | string,
        public usuario?: Usuario,
        public fechaCompletada?: string
    ) { }
}
